import { Fragment, useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarProveedores, limpiarProveedores, filtarProveedores } from '../../actions/proveedores';

import EliminarProveedor from './EliminarProveedor';

const Proveedores = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Proveedores',
            path: '/proveedores'
        }
    ];

    const dispatch  = useDispatch();
    const { listado } = useSelector(state => state.proveedores);

    const [proveedores, setProveedores] = useState([]);
    const [proveedorEliminar, setProveedorEliminar] = useState(null);

    // --- estados para filtros ---
    const [busquedaGeneral, setBusquedaGeneral] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroContacto, setFiltroContacto] = useState('');

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre,
            wrap: true,       // permite salto de línea
            grow: 2           // le da más espacio horizontal
        },
        {
            name: 'Correo',
            sortable: true,
            selector: row => row.correo,
            wrap: true
        },
        {
            name: 'Dirección',
            sortable: true,
            selector: row => row.direccion,
            wrap: true,
            grow: 2
        },
        {
            name: 'Teléfono',
            sortable: true,
            selector: row => row.telefono,
        },
        {
            name: 'RFC',
            sortable: true,
            selector: row => row.rfc,
        },
        {
            name: 'Contacto',
            sortable: true,
            selector: row => row.contacto,
            wrap: true
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        <button
                            type="button"
                            className="btn btn-sm btn-link px-2 float-end"
                            onClick={() => handleEliminarProveedor(row)}
                        >
                            <i className="fas fa-trash text-danger"></i>
                        </button>
                        <Link className="btn btn-sm btn-link px-2 float-end" to={`/proveedores/editar/${row._id}`}>
                            <i className="fas fa-edit text-warning"></i>
                        </Link>
                        <Link className="btn btn-sm btn-link px-2 float-end" to={`/proveedores/productos/${row._id}`}>
                            <i className="fas fa-list text-info"></i>
                        </Link>
                    </div>
                )
            }
        }
    ];

    /* Filtros de busqueda (backend si lo llegas a usar después) */
    const handleFiltrosBusqueda = () => {
        dispatch(filtarProveedores(true));
    }

    /* Eliminar proveedor */
    const handleEliminarProveedor = (proveedor) => {
        setProveedorEliminar(proveedor);
    }

    /* Limpiar filtros de frontend */
    const handleLimpiarFiltros = () => {
        setBusquedaGeneral('');
        setFiltroNombre('');
        setFiltroContacto('');
    }

    // --- aplicar filtros en memoria ---
    const proveedoresFiltrados = useMemo(() => {
        return proveedores.filter(p => {
            const textoGeneral  = busquedaGeneral.toLowerCase();
            const textoNombre   = filtroNombre.toLowerCase();
            const textoContacto = filtroContacto.toLowerCase();

            const camposGenerales = [
                p.nombre,
                p.correo,
                p.direccion,
                p.telefono,
                p.rfc,
                p.contacto
            ];

            const coincideGeneral =
                !textoGeneral ||
                camposGenerales.some(campo =>
                    (campo || '').toLowerCase().includes(textoGeneral)
                );

            const coincideNombre =
                !textoNombre ||
                (p.nombre || '').toLowerCase().includes(textoNombre);

            const coincideContacto =
                !textoContacto ||
                (p.contacto || '').toLowerCase().includes(textoContacto);

            return coincideGeneral && coincideNombre && coincideContacto;
        });
    }, [proveedores, busquedaGeneral, filtroNombre, filtroContacto]);

    useEffect(() => {
        dispatch(buscarProveedores({
            id: null,
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            tipo: null,
            fecha_inicio: null,
            fecha_fin: null
        }));

        return () => {
            dispatch(limpiarProveedores());
        }
    }, []);

    useEffect(() => {
        setProveedores(listado || []);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <EliminarProveedor proveedor={proveedorEliminar} reestablecerProveedor={handleEliminarProveedor} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Proveedores</h3>

                    <div className="d-flex justify-content-end mb-3">
                        <button
                            type="button"
                            className="btn btn-primary me-2 d-none"
                            onClick={handleFiltrosBusqueda}
                        >
                            Filtros de búsqueda
                        </button>

                        
                    </div>

                    {/* Barra de búsqueda y filtros por columna */}
                    <div className="mb-3">
                        <div className="row g-2 d-flex justify-content-end mb-3">
                            <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar en todos los campos..."
                                    value={busquedaGeneral}
                                    onChange={e => setBusquedaGeneral(e.target.value)}
                                />
                            </div>
                            <div className="col-md-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Filtrar por nombre"
                                    value={filtroNombre}
                                    onChange={e => setFiltroNombre(e.target.value)}
                                />
                            </div>
                            <div className="col-md-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Filtrar por contacto"
                                    value={filtroContacto}
                                    onChange={e => setFiltroContacto(e.target.value)}
                                />
                            </div>
                            <div className="col-md-2 ">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary w-100"
                                    onClick={handleLimpiarFiltros}
                                >
                                    Limpiar filtros
                                </button>
                            </div>
                            <div className="col-md-2 ">
                                <Link to="/proveedores/nuevo">
                                    <button className="btn btn-primary w-100">Agregar Proveedor</button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={proveedoresFiltrados}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover
                            persistTableHead
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Proveedores;
